// import React, { useState } from "react";

// import LinkToRegistration from "../property/component/LinkToRegistration";
// import Stepper from "../Stepper/component/Stepper";
// import Navbar from "../navbar/Navbar";
// import { useSelector } from "react-redux";
// import { selectPdEId } from "../property/propertySlice";
// import { selectPDEInfo } from "../user/userSlice";
// import API_BASE_URL, { API_BASE_URL_CRYS } from "../BaseURL/baseURL";

// const UploadDocument = () => {
//   const [stampDutyCert, setStampDutyCert] = useState("");
//   const [stampIssueDate, setStampIssueDate] = useState("");

//   const pde = useSelector(selectPdEId);
//   const [files, setFiles] = useState({
//     idCard: null,
//     photo: null,
//     poaDetails: null,
//     property: null,
//     boundary: null,
//   });
//   const [boundryDetails, setBoundryDetails] = useState({
//     east: "",
//     west: "",
//     north: "",
//     south: "",
//   });
//   const [history, setHistory] = useState("");
//   const [additionalDetails, setAdditionalDetails] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const pdeInfo = useSelector(selectPDEInfo);
//   const pdeData = pdeInfo?.pdeData[0];

//   const deedcode = pdeData.deedcode;
//   console.log("deedcode : ", deedcode);
//   const handleFileChange = (e) => {
//     const { name, files } = e.target;
//     setFiles((prev) => ({
//       ...prev,
//       [name]: files[0], // Store the first file from input
//     }));
//   };
//   const handleSaveClick = () => {
//     setIsModalOpen(true); // Open modal
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false); // Close modal
//   };
//   const handleViewDocument = () => {
//     setIsModalOpen(false); // Close modal
//   };

//   const handleConfirm = async () => {
//     debugger;
//     setLoading(true);
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/UploadDoc/GetBase64PDF?pde_id=${pde}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Failed to fetch PDF");
//       }

//       const data = await response.json(); // Assuming API returns { base64: "..." }

//       if (data.base64) {
//         // Convert Base64 to Blob
//         const byteCharacters = atob(data.base64);
//         const byteNumbers = new Array(byteCharacters.length);
//         for (let i = 0; i < byteCharacters.length; i++) {
//           byteNumbers[i] = byteCharacters.charCodeAt(i);
//         }
//         const byteArray = new Uint8Array(byteNumbers);
//         const blob = new Blob([byteArray], { type: "application/pdf" });

//         // Create a URL and open in new tab
//         const pdfUrl = URL.createObjectURL(blob);
//         window.open(pdfUrl, "_blank");
//         setIsModalOpen(false);
//       } else {
//         alert("Invalid PDF data received");
//       }
//     } catch (error) {
//       console.error("Error fetching PDF:", error);
//       alert("Failed to fetch PDF");
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleboundrydetailsChange = (e) => {
//     const { id, value } = e.target;
//     setBoundryDetails((prev) => ({
//       ...prev,
//       [id]: value, // Store the first file from input
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     debugger;
//     const form = e.target;
//     if (form.checkValidity() === false) {
//       alert("Please fill all required fields.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("stampDutyCert", stampDutyCert);
//     formData.append("stampIssueDate", stampIssueDate);
//     formData.append("idCard", files.idCard);
//     formData.append("history", history);
//     formData.append("additionalDetails", additionalDetails);
//     formData.append("pde_id", pde);

//     if (deedcode === "05") {
//       formData.append("photo", files.photo);
//       formData.append("poaDetails", files.poaDetails);
//     } else {
//       formData.append("property", files.property);
//       formData.append("boundary", files.boundary);
//       formData.append("east", boundryDetails.east);
//       formData.append("west", boundryDetails.west);
//       formData.append("north", boundryDetails.north);
//       formData.append("south", boundryDetails.south);
//     }

//     try {
//       const url =
//         // deedcode === "05"
//         //   ? "https://localhost:44378/UploadDoc/UploadDocuments_POA"
//         //   : "https://localhost:44378/uploadDoc/UploadDocuments_all";
//         deedcode === "05"
//           ? `${API_BASE_URL_CRYS}/UploadDoc/UploadDocuments_POA`
//           : `${API_BASE_URL_CRYS}/uploadDoc/UploadDocuments_all`;

//       const response = await fetch(url, {
//         method: "POST",
//         body: formData,
//       });

//       if (response.ok) {
//         debugger;
//         setIsModalOpen(true);
//         console.log("Documents uploaded successfully!");
//       } else {
//         const errorMessage = await response.text();
//         console.error("Upload failed:", errorMessage);
//         alert("Failed to upload documents. Server Response: " + errorMessage);
//       }
//     } catch (error) {
//       console.error("Error uploading files", error);
//       alert("An error occurred while uploading documents.");
//     }
//   };
//   return (
//     <>
//       <Navbar />
//       <LinkToRegistration />
//       <div className="flex min-h-screen">
//         <div className="w-1/5 bg-white flex justify-center">
//           <Stepper />
//         </div>
//         <div className="w-0.5 border-none bg-neutral-400"></div>
//         <div className="w-4/5 flex justify-center">
//           <div className="w-full py-6 ps-4 bg-gray-50 rounded-lg">
//             <div className="space-y-4">
//               <form
//                 className="w-full py-6 ps-4 bg-gray-50 rounded-lg space-y-4"
//                 onSubmit={handleSubmit}
//               >
//                 <div className="container">
//                   <div className="grid grid-flow-row justify-start">
//                     <p className="text-center font-semibold text-lg mb-5">
//                       Upload Documents
//                     </p>
//                     <p className="font-medium mb-4">
//                       PDE Unique ID:{" "}
//                       <span className="text-blue-600">{pde}</span>
//                     </p>

//                     <h5 className="text-red-600 font-semibold mb-4">
//                       Important Note: For Paperless Registration, uploading a
//                       document in a single PDE is mandatory.
//                     </h5>

//                     <div className="grid grid-cols-4 mt-2">
//                       <div className="flex items-center">
//                         <h6 className="font-semibold">
//                           Upload Identification card PDF:
//                         </h6>
//                       </div>

//                       <div className="grid grid-cols-1 md:grid-cols-2 gap-4 col-span-3 mt-2">
//                         {/* Stamp Duty Certificate No */}
//                         <div className="grid grid-cols-2 items-center">
//                           <input
//                             type="file"
//                             name="idCard"
//                             onChange={handleFileChange}
//                             className="border rounded p-2"
//                             required
//                           />
//                         </div>
//                       </div>
//                     </div>
//                     {deedcode !== "05" && (
//                       <>
//                         <div className="grid grid-cols-4 mt-2">
//                           <div className="flex items-center">
//                             <h6 className="font-semibold">
//                               Upload Property Photo PDF:
//                             </h6>
//                           </div>

//                           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 col-span-3 mt-2">
//                             {/* Stamp Duty Certificate No */}
//                             <div className="grid grid-cols-2 items-center">
//                               <input
//                                 type="file"
//                                 name="property"
//                                 onChange={handleFileChange}
//                                 className="border rounded p-2"
//                                 required
//                               />
//                             </div>
//                           </div>
//                         </div>
//                         <div className="grid grid-cols-4 mt-2">
//                           <div className="flex items-center">
//                             <h6 className="font-semibold">
//                               Upload Boundaries PDF:
//                             </h6>
//                           </div>

//                           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 col-span-3 mt-2">
//                             {/* Stamp Duty Certificate No */}
//                             <div className="grid grid-cols-2 items-center">
//                               <input
//                                 type="file"
//                                 name="boundary"
//                                 onChange={handleFileChange}
//                                 className="border rounded p-2"
//                                 required
//                               />
//                             </div>
//                           </div>
//                         </div>
//                         <div className="grid grid-cols-4 mt-2">
//                           <div className="flex items-center">
//                             <h6 className="font-semibold">
//                               Property Boundaries Details:
//                             </h6>
//                           </div>

//                           <div className="grid grid-cols-1 md:grid-cols-4 gap-4 col-span-3 mt-2">
//                             {/* Stamp Duty Certificate No */}
//                             <div className="grid grid-cols-1 items-center">
//                               <div class="relative z-0">
//                                 <input
//                                   type="text"
//                                   id="east"
//                                   value={boundryDetails.east}
//                                   onChange={handleboundrydetailsChange}
//                                   class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
//                                   placeholder=" "
//                                   required
//                                 />
//                                 <label
//                                   for="east"
//                                   class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
//                                 >
//                                   East
//                                 </label>
//                               </div>
//                             </div>
//                             <div className="grid grid-cols-1 items-center">
//                               <div class="relative z-0">
//                                 <input
//                                   type="text"
//                                   id="west"
//                                   value={boundryDetails.west}
//                                   onChange={handleboundrydetailsChange}
//                                   class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
//                                   placeholder=" "
//                                   required
//                                 />
//                                 <label
//                                   for="west"
//                                   class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
//                                 >
//                                   West
//                                 </label>
//                               </div>
//                             </div>
//                             <div className="grid grid-cols-1 items-center">
//                               <div class="relative z-0">
//                                 <input
//                                   type="text"
//                                   id="north"
//                                   value={boundryDetails.north}
//                                   onChange={handleboundrydetailsChange}
//                                   class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
//                                   placeholder=" "
//                                   required
//                                 />
//                                 <label
//                                   for="north"
//                                   class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
//                                 >
//                                   North
//                                 </label>
//                               </div>
//                             </div>
//                             <div className="grid grid-cols-1 items-center">
//                               <div class="relative z-0">
//                                 <input
//                                   type="text"
//                                   id="south"
//                                   value={boundryDetails.south}
//                                   onChange={handleboundrydetailsChange}
//                                   class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
//                                   placeholder=" "
//                                   required
//                                 />
//                                 <label
//                                   for="south"
//                                   class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
//                                 >
//                                   South
//                                 </label>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </>
//                     )}
//                     {deedcode === "05" && (
//                       <>
//                         <div className="grid grid-cols-4 mt-2">
//                           <div className="flex items-center">
//                             <h6 className="font-semibold">
//                               मुख्तारदाता Photo:
//                             </h6>
//                           </div>

//                           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 col-span-3 mt-2">
//                             {/* Stamp Duty Certificate No */}
//                             <div className="grid grid-cols-2 items-center">
//                               <input
//                                 type="file"
//                                 name="photo"
//                                 onChange={handleFileChange}
//                                 className="border rounded p-2"
//                                 required
//                               />
//                             </div>
//                           </div>
//                         </div>
//                         <div className="grid grid-cols-4 mt-2">
//                           <div className="flex items-center">
//                             <h6 className="font-semibold">
//                               Upload POA Details and Fingerprint Pdf :
//                             </h6>
//                           </div>

//                           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 col-span-3 mt-2">
//                             {/* Stamp Duty Certificate No */}
//                             <div className="grid grid-cols-2 items-center">
//                               <input
//                                 type="file"
//                                 name="poaDetails"
//                                 onChange={handleFileChange}
//                                 className="border rounded p-2"
//                                 required
//                               />
//                             </div>
//                           </div>
//                         </div>
//                       </>
//                     )}
//                     <div className="grid grid-cols-4 mt-2">
//                       <div className="flex items-center">
//                         <h6 className="font-semibold">History :</h6>
//                       </div>

//                       <div className="grid grid-cols-1 md:grid-cols-2 gap-4 col-span-3 mt-2">
//                         {/* Stamp Duty Certificate No */}
//                         <div className="grid grid-cols-1 items-center">
//                           <textarea
//                             className="col-span-3 border p-2"
//                             value={history}
//                             onChange={(e) => setHistory(e.target.value)}
//                             required
//                           />
//                         </div>
//                       </div>
//                     </div>
//                     <div className="grid grid-cols-4 mt-2">
//                       <div className="flex items-center">
//                         <div className="items-center">
//                           <h6 className="font-semibold">Additional Details</h6>

//                           <span>(*if Deedwriter want to provide) :</span>
//                         </div>
//                       </div>
//                       <div className="grid grid-cols-2 md:grid-cols-2 gap-4 col-span-3 mt-2">
//                         {/* Stamp Duty Certificate No */}
//                         <div className="grid grid-cols-1 items-center">
//                           <textarea
//                             className="col-span-3 border p-2"
//                             value={additionalDetails}
//                             onChange={(e) =>
//                               setAdditionalDetails(e.target.value)
//                             }
//                             required
//                           />
//                         </div>
//                       </div>
//                     </div>
//                     <div className="justify-content-center mt-5">
//                       <button
//                         //onClick={handleSubmit}
//                         type="submit"
//                         className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
//                       >
//                         Save
//                       </button>
//                     </div>
//                     <div className="justify-content-center mt-5">
//                       <button
//                         onClick={handleConfirm}
//                         className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
//                       >
//                         Preview Deed
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//       {isModalOpen && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
//             <h2 className="text-xl text-center font-semibold">
//               Document Saved Successfully !!!
//             </h2>

//             <div className="mt-4 flex justify-center space-x-2">
//               <button
//                 className="bg-blue-500 text-white px-4 py-2 rounded"
//                 onClick={handleConfirm}
//                 disabled={loading}
//               >
//                 {loading ? "Loading..." : "Preview Deed"}
//               </button>
//               <button
//                 className="bg-red-500 text-white px-4 py-2 rounded"
//                 onClick={handleCloseModal}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default UploadDocument;

// src/components/UploadDocument.js
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useForm } from "react-hook-form";
// import Navbar from "../navbar/Navbar";
// import LinkToRegistration from "../property/component/LinkToRegistration";
// import Stepper from "../Stepper/component/Stepper";
// import { selectPdEId } from "../property/propertySlice";
// import { selectPDEInfo } from "../user/userSlice";
// import {
//   loadDocumentDetails,
//   previewDeed,
//   selectDeedBase64,
//   selectUploadDetails,
//   selectUploadError,
//   selectUploadStatus,
//   submitDocuments,
// } from "./UploadDocumentSlice";
// import { completeStep, nextStep } from "../Stepper/stepperSlice";
// import { useNavigate } from "react-router-dom";

// const UploadDocument = () => {
//   const dispatch = useDispatch();
//   const pde = useSelector(selectPdEId);
//   const pdeInfo = useSelector(selectPDEInfo);
//   const deedcode = pdeInfo?.pdeData?.[0]?.deedcode;

//   const details = useSelector(selectUploadDetails);
//   const status = useSelector(selectUploadStatus);
//   const error = useSelector(selectUploadError);
//   const deedBase64 = useSelector(selectDeedBase64);

//   const { register, handleSubmit, reset } = useForm();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [loadingPreview, setLoadingPreview] = useState(false);
//   const Navigate = useNavigate();

//   useEffect(() => {
//     if (pde) dispatch(loadDocumentDetails(pde));
//   }, [pde, dispatch]);

//   useEffect(() => {
//     if (details) {
//       reset({
//         stampDutyCert: details.stampDutyCert || "",
//         stampIssueDate: details.stampIssueDate || "",
//         history: details.history || "",
//         additionalDetails: details.additionalDetails || "",
//         east: details.east || "",
//         west: details.west || "",
//         north: details.north || "",
//         south: details.south || "",
//       });
//     }
//   }, [details, reset]);

//   const onSubmit = (data) => {
//     debugger;
//     const formData = new FormData();
//     formData.append("pde_id", pde);
//     // formData.append("stampDutyCert", data.stampDutyCert);
//     // formData.append("stampIssueDate", data.stampIssueDate);
//     formData.append("history", data.history);
//     formData.append("additionalDetails", data.additionalDetails);
//     formData.append("idCard", data.idCard[0]);

//     if (deedcode === "05") {
//       formData.append("photo", data.photo[0]);
//       formData.append("poaDetails", data.poaDetails[0]);
//     } else {
//       formData.append("property", data.property[0]);
//       formData.append("boundary", data.boundary[0]);
//       formData.append("east", data.east);
//       formData.append("west", data.west);
//       formData.append("north", data.north);
//       formData.append("south", data.south);
//     }

//     dispatch(submitDocuments({ formData, isPOA: deedcode === "05" }))
//       .unwrap()
//       .then(() => setIsModalOpen(true))
//       .catch((err) => alert(`Upload failed: ${err}`));
//   };

//   const handleConfirm = () => {
//     setLoadingPreview(true);
//     dispatch(previewDeed(pde))
//       .unwrap()
//       .then((base64) => {
//         const bytes = atob(base64);
//         const arr = new Uint8Array(bytes.length);
//         for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
//         const blob = new Blob([arr], { type: "application/pdf" });
//         window.open(URL.createObjectURL(blob), "_blank");
//         setIsModalOpen(false);
//       })
//       .catch((err) => alert(`Preview failed: ${err}`))
//       .finally(() => setLoadingPreview(false));
//   };

//   const handleNext = () => {
//     dispatch(nextStep());
//     dispatch(completeStep({ step: 4, completed: true }));
//     Navigate("/ReviewApproval");
//   };

//   return (
//     <>
//       <Navbar />
//       <LinkToRegistration />
//       <div className="flex min-h-screen">
//         <div className="w-1/5 bg-white flex justify-center">
//           <Stepper />
//         </div>
//         <div className="w-0.5 bg-neutral-400" />
//         <div className="w-4/5 flex justify-center">
//           <div className="w-full py-6 ps-4 bg-gray-50 rounded-lg">
//             {/* {error && <div className="text-red-600 mb-4">{error}</div>} */}
//             <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
//               <p className="text-center font-semibold text-lg mb-5">
//                 Upload Documents
//               </p>
//               <p className="font-medium mb-4">
//                 PDE Unique ID: <span className="text-blue-600">{pde}</span>
//               </p>
//               <h5 className="text-red-600 font-semibold mb-4">
//                 Important Note: For Paperless Registration, uploading a document
//                 in a single PDE is mandatory.
//               </h5>

//               <div className="grid grid-cols-4 mt-2 items-center">
//                 <h6 className="font-semibold">Upload Identification card:</h6>
//                 <div className="col-span-3 grid grid-cols-2 gap-4">
//                   <input
//                     {...register("idCard", { required: true })}
//                     type="file"
//                     accept="application/pdf"
//                     className="border rounded p-2 w-1/2"
//                     required
//                   />
//                   {details?.idCardName && (
//                     <span>Current: {details.idCardName}</span>
//                   )}
//                 </div>
//               </div>
//               {deedcode !== "05" ? (
//                 <>
//                   {/* Property Photo – PNG/JPG only, smaller input */}
//                   <div className="grid grid-cols-4 mt-2 items-center">
//                     <h6 className="font-semibold">Upload Property Photo:</h6>
//                     <div className="col-span-3 grid grid-cols-2 gap-4">
//                       <input
//                         {...register("property", { required: true })}
//                         type="file"
//                         accept="image/png,image/jpeg"
//                         className="border rounded p-2 w-1/2"
//                         required
//                       />
//                       {details?.propertyName && (
//                         <span>Current: {details.propertyName}</span>
//                       )}
//                     </div>
//                   </div>

//                   {/* Boundaries PDF – now half-width too */}
//                   <div className="grid grid-cols-4 mt-2 items-center">
//                     <h6 className="font-semibold">Upload Boundaries PDF:</h6>
//                     <div className="col-span-3 grid grid-cols-2 gap-4">
//                       <input
//                         {...register("boundary", { required: true })}
//                         type="file"
//                         accept="application/pdf"
//                         className="border rounded p-2 w-1/2"
//                         required
//                       />
//                       {details?.boundaryName && (
//                         <span>Current: {details.boundaryName}</span>
//                       )}
//                     </div>
//                   </div>

//                   {/* Boundary Details (unchanged) */}
//                   <div className="grid grid-cols-4 mt-2">
//                     <h6 className="font-semibold">
//                       Property Boundaries Details:
//                     </h6>
//                     <div className="col-span-3 grid grid-cols-4 gap-4">
//                       {["east", "west", "north", "south"].map((dir) => (
//                         <div key={dir} className="relative z-0">
//                           <input
//                             {...register(dir, { required: true })}
//                             id={dir}
//                             type="text"
//                             className="block py-2.5 px-0 w-full text-sm bg-transparent border-0 border-b-2 border-gray-300 focus:outline-none focus:border-blue-600 peer"
//                             placeholder=" "
//                             required
//                           />
//                           <label
//                             htmlFor={dir}
//                             className="absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0]
//                          peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
//                           >
//                             {dir.charAt(0).toUpperCase() + dir.slice(1)}
//                           </label>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   {/* Photo – smaller input */}
//                   <div className="grid grid-cols-4 mt-2 items-center">
//                     <h6 className="font-semibold">Photo:</h6>
//                     <div className="col-span-3 grid grid-cols-2 gap-4">
//                       <input
//                         {...register("photo", { required: true })}
//                         type="file"
//                         // accept="application/pdf"
//                         accept="image/png,image/jpeg"
//                         className="border rounded p-2 w-1/2"
//                         required
//                       />
//                       {details?.photoName && (
//                         <span>Current: {details.photoName}</span>
//                       )}
//                     </div>
//                   </div>

//                   {/* POA Details – smaller input */}
//                   <div className="grid grid-cols-4 mt-2 items-center">
//                     <h6 className="font-semibold">
//                       Upload POA & Fingerprint PDF:
//                     </h6>
//                     <div className="col-span-3 grid grid-cols-2 gap-4">
//                       <input
//                         {...register("poaDetails", { required: true })}
//                         type="file"
//                         accept="application/pdf"
//                         className="border rounded p-2 w-1/2"
//                         required
//                       />
//                       {details?.poaDetailsName && (
//                         <span>Current: {details.poaDetailsName}</span>
//                       )}
//                     </div>
//                   </div>
//                 </>
//               )}
//               <div className="grid grid-cols-4 mt-4">
//                 <h6 className="flex items-center font-semibold">History :</h6>
//                 <div className="col-span-3">
//                   <textarea
//                     {...register("history", { required: true })}
//                     className="border p-2 w-1/2"
//                     rows={3}
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="grid grid-cols-4 mt-2">
//                 <div>
//                   <h6 className="font-semibold">Additional Details</h6>
//                   <span>(*if Deedwriter wants to provide) :</span>
//                 </div>
//                 <div className="col-span-3">
//                   <textarea
//                     {...register("additionalDetails")}
//                     className="border p-2 w-1/2"
//                     rows={3}
//                   />
//                 </div>
//               </div>
//               {/* Buttons */}
//               <div className="flex justify-center gap-4 mt-5">
//                 <button
//                   type="submit"
//                   className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
//                   disabled={status === "submitting"}
//                 >
//                   {status === "submitting" ? "Saving..." : "Save"}
//                 </button>
//                 <button
//                   type="button"
//                   onClick={handleConfirm}
//                   className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
//                   disabled={loadingPreview}
//                 >
//                   {loadingPreview ? "Loading..." : "Preview Deed"}
//                 </button>

//                 <button
//                   type="button"
//                   onClick={handleNext}
//                   className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
//                 >
//                   Next
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>

//       {isModalOpen && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
//             <h2 className="text-xl text-center font-semibold">
//               Document Saved Successfully!
//             </h2>
//             <div className="mt-4 flex justify-center space-x-2">
//               <button
//                 onClick={handleConfirm}
//                 className="bg-blue-500 text-white px-4 py-2 rounded"
//                 disabled={loadingPreview}
//               >
//                 {loadingPreview ? "Loading..." : "Preview Deed"}
//               </button>
//               <button
//                 onClick={() => setIsModalOpen(false)}
//                 className="bg-red-500 text-white px-4 py-2 rounded"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default UploadDocument;

// new testing code starts

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Navbar from "../navbar/Navbar";
import LinkToRegistration from "../property/component/LinkToRegistration";
import Stepper from "../Stepper/component/Stepper";
import { selectPdEId } from "../property/propertySlice";
import { selectPDEInfo } from "../user/userSlice";
import {
  loadDocumentDetails,
  previewDeed,
  selectUploadDetails,
  selectUploadError,
  selectUploadStatus,
  submitDocuments,
} from "./UploadDocumentSlice";
import { completeStep, nextStep } from "../Stepper/stepperSlice";
import { useNavigate } from "react-router-dom";

// Configuration for deed-specific fields
const deedFieldGroups = [
  {
    codes: ["05", "06"],
    fields: [
      {
        name: "photo",
        label: "Photo",
        type: "file",
        accept: "image/png,image/jpeg",
      },
      {
        name: "poaDetails",
        label: "Upload POA & Fingerprint PDF",
        type: "file",
        accept: "application/pdf",
      },
    ],
  },
  {
    codes: ["07", "20"],
    fields: [
      {
        name: "otherDetails",
        label: "Upload Fingerprint & Other Details PDF",
        type: "file",
        accept: "application/pdf",
      },
      ...["east", "west", "north", "south"].map((dir) => ({
        name: dir,
        label: dir.charAt(0).toUpperCase() + dir.slice(1),
        type: "text",
      })),
    ],
  },
  {
    // default for all other deed codes
    codes: [],
    fields: [
      {
        name: "property",
        label: "Upload Property Photo",
        type: "file",
        // accept: "image/png,image/jpeg",
        accept: "application/pdf",
      },
      {
        name: "boundary",
        label: "Upload Boundaries PDF",
        type: "file",
        accept: "application/pdf",
      },
      {
        name: "otherDetails",
        label: "Upload Fingerprint & Other Details PDF",
        type: "file",
        accept: "application/pdf",
      },
      // boundary text inputs
      ...["east", "west", "north", "south"].map((dir) => ({
        name: dir,
        label: dir.charAt(0).toUpperCase() + dir.slice(1),
        type: "text",
      })),
    ],
  },
];

// Component to render dynamic fields based on deedcode
function UploadFields({ deedcode, register, details }) {
  const group =
    deedFieldGroups.find((g) => g.codes.includes(deedcode)) ||
    deedFieldGroups.find((g) => g.codes.length === 0);

  return (
    <>
      {group.fields.map((field) => (
        <div key={field.name} className="grid grid-cols-4 mt-2 items-center">
          <h6 className="font-semibold">{field.label}:</h6>
          <div className="col-span-3 grid grid-cols-2 gap-4">
            {field.type === "file" ? (
              <input
                {...register(field.name, { required: true })}
                type="file"
                accept={field.accept}
                className="border rounded p-2 w-1/2"
                required
              />
            ) : (
              <input
                {...register(field.name, { required: true })}
                type="text"
                className="border rounded p-2 w-1/2"
                placeholder={field.label}
                required
              />
            )}
            {details?.[`${field.name}Name`] && (
              <span>Current: {details[`${field.name}Name`]}</span>
            )}
          </div>
        </div>
      ))}
    </>
  );
}

const UploadDocument = () => {
  const dispatch = useDispatch();
  const pde = useSelector(selectPdEId);
  const pdeInfo = useSelector(selectPDEInfo);
  const deedcode = pdeInfo?.pdeData?.[0]?.deedcode;

  const details = useSelector(selectUploadDetails);
  const status = useSelector(selectUploadStatus);
  const error = useSelector(selectUploadError);

  const { register, handleSubmit, reset } = useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const navigate = useNavigate();
  const [isSystemGenerated, setIsSystemGenerated] = useState("yes");

  useEffect(() => {
    if (pde) dispatch(loadDocumentDetails(pde));
  }, [pde, dispatch]);

  useEffect(() => {
    if (details) {
      reset({
        history: details.history || "",
        additionalDetails: details.additionalDetails || "",
        east: details.east || "",
        west: details.west || "",
        north: details.north || "",
        south: details.south || "",
      });
    }
  }, [details, reset]);

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("pde_id", pde);
    formData.append("history", data.history);
    formData.append("additionalDetails", data.additionalDetails || "");
    formData.append("idCard", data.idCard[0]);
    formData.append("uploadedDeed", data.uploadedDeed[0]);
    formData.append("radioYesNO", isSystemGenerated);

    // append dynamic fields
    const group =
      deedFieldGroups.find((g) => g.codes.includes(deedcode)) ||
      deedFieldGroups.find((g) => g.codes.length === 0);
    group.fields.forEach((field) => {
      if (field.type === "file") {
        formData.append(field.name, data[field.name][0]);
      } else {
        formData.append(field.name, data[field.name]);
      }
    });

    dispatch(
      submitDocuments({
        formData,
        isPOA: deedcode === "05" || deedcode === "06",
        isOther: deedcode === "07" || deedcode === "20",
      })
    )
      .unwrap()
      .then(() => setIsModalOpen(true))
      .catch((err) => alert(`Upload failed: ${err}`));
  };

  const handleConfirm = () => {
    setLoadingPreview(true);
    dispatch(previewDeed(pde))
      .unwrap()
      .then((base64) => {
        const bytes = atob(base64);
        const arr = new Uint8Array(bytes.length);
        for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
        const blob = new Blob([arr], { type: "application/pdf" });
        window.open(URL.createObjectURL(blob), "_blank");
        setIsModalOpen(false);
      })
      .catch((err) => alert(`Preview failed: ${err}`))
      .finally(() => setLoadingPreview(false));
  };

  const handleNext = () => {
    dispatch(nextStep());
    dispatch(completeStep({ step: 4, completed: true }));
    navigate("/ReviewApproval");
  };

  return (
    <>
      <Navbar />
      <LinkToRegistration />
      <div className="flex min-h-screen">
        <div className="w-1/5 bg-white flex justify-center">
          <Stepper />
        </div>
        <div className="w-0.5 bg-neutral-400" />
        <div className="w-4/5 flex justify-center">
          <div className="w-full py-6 ps-4 bg-gray-50 rounded-lg">
            {error && <div className="text-red-600 mb-4">{error}</div>}
            <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
              <p className="text-center font-semibold text-lg mb-5">
                Upload Documents
              </p>
              <p className="font-medium mb-4">
                PDE Unique ID: <span className="text-blue-600">{pde}</span>
              </p>
              <h5 className="text-red-600 font-semibold mb-4">
                Important Note: For Paperless Registration, uploading a document
                in a single PDE is mandatory.
              </h5>

              {/* Identification card */}
              <div className="grid grid-cols-4 mt-2 items-center">
                <h6 className="font-semibold">Upload Identification card:</h6>
                <div className="col-span-3 grid grid-cols-2 gap-4">
                  <input
                    {...register("idCard", { required: true })}
                    type="file"
                    accept="application/pdf"
                    className="border rounded p-2 w-1/2"
                    required
                  />
                  {details?.idCardName && (
                    <span>Current: {details.idCardName}</span>
                  )}
                </div>
              </div>

              {/* System Generated Deed Radio Buttons */}
              <div className="grid grid-cols-4 mt-4 items-center">
                <h6 className="font-semibold">System Generated Deed:</h6>
                <div className="col-span-3 flex gap-6">
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="systemDeed"
                      value="yes"
                      checked={isSystemGenerated === "yes"}
                      onChange={(e) => setIsSystemGenerated(e.target.value)}
                    />
                    Yes
                  </label>

                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="systemDeed"
                      value="no"
                      checked={isSystemGenerated === "no"}
                      onChange={(e) => setIsSystemGenerated(e.target.value)}
                    />
                    No
                  </label>
                </div>
              </div>

              {/* Show Upload Section only if "No" selected */}
              {isSystemGenerated === "no" && (
                <div className="grid grid-cols-4 mt-2 items-center">
                  <h6 className="font-semibold">Upload Deed:</h6>
                  <div className="col-span-3 grid grid-cols-2 gap-4">
                    <input
                      {...register("uploadedDeed", { required: true })}
                      type="file"
                      accept="application/pdf"
                      className="border rounded p-2 w-1/2"
                      required
                    />
                    {details?.uploadedDeedName && (
                      <span>Current: {details.uploadedDeedName}</span>
                    )}
                  </div>
                </div>
              )}

              {/* Dynamic deed-specific fields */}
              <UploadFields
                deedcode={deedcode}
                register={register}
                details={details}
              />

              {/* History */}
              <div className="grid grid-cols-4 mt-4">
                <h6 className="flex items-center font-semibold">History :</h6>
                <div className="col-span-3">
                  <textarea
                    {...register("history", { required: true })}
                    className="border p-2 w-1/2"
                    rows={3}
                    required
                  />
                </div>
              </div>

              {/* Additional details */}
              <div className="grid grid-cols-4 mt-2">
                <div>
                  <h6 className="font-semibold">Additional Details</h6>
                  <span>(*if Deedwriter wants to provide) :</span>
                </div>
                <div className="col-span-3">
                  <textarea
                    {...register("additionalDetails")}
                    className="border p-2 w-1/2"
                    rows={3}
                  />
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-center gap-4 mt-5">
                <button
                  type="submit"
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
                  disabled={status === "submitting"}
                >
                  {status === "submitting" ? "Saving..." : "Save"}
                </button>
                <button
                  type="button"
                  onClick={handleConfirm}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
                  disabled={loadingPreview}
                >
                  {loadingPreview ? "Loading..." : "Preview Deed"}
                </button>
                <button
                  type="button"
                  onClick={handleNext}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                  Next
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Success modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
            <h2 className="text-xl text-center font-semibold">
              Document Saved Successfully!
            </h2>
            <div className="mt-4 flex justify-center space-x-2">
              <button
                onClick={handleConfirm}
                className="bg-blue-500 text-white px-4 py-2 rounded"
                disabled={loadingPreview}
              >
                {loadingPreview ? "Loading..." : "Preview Deed"}
              </button>
              <button
                onClick={() => setIsModalOpen(false)}
                className="bg-red-500 text-white px-4 py-2 rounded"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UploadDocument;
